import { PhoneHangUpIcon } from '@rsos/assets/icons';
import { StyledButton } from './DispatcherControls.styles';

export const EndCallButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <StyledButton title="End call" onClick={onClick} btnType="warning_primary">
      <PhoneHangUpIcon />
    </StyledButton>
  );
};
